import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { EmployeeInfo, WebCompany } from "src/app/models";
import { CompanyService } from "src/app/services";
import { AlertDialogComponent } from "../alert-dialog/alert-dialog.component";
import { MatDialog } from "@angular/material/dialog";


@Component({
    selector: 'app-verify-employee-dialog',
    templateUrl: './verify-employee-dialog.component.html',
    styleUrls: ['./verify-employee-dialog.component.scss']
})

export class VerifyEmployeeDialogComponent
{

    webEmail: string;
    company: WebCompany;

    maskedEmail: string;
    maskedPhoneNumber: string;
    username: string;
    selectedMethod: any = null;

    constructor(
        public dialogRef: MatDialogRef<VerifyEmployeeDialogComponent>,
        private companyService: CompanyService,
        private alertDialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: EmployeeInfo
    ) { }

    ngOnInit(): void
    {
        this.companyService.company.subscribe(c =>
        {
            this.company = c;
            this.webEmail = this.company.WebEmail ? this.company.WebEmail : this.company.CorpEmail;
        });
        this.maskedEmail = this.data.Email;
        this.maskedPhoneNumber = this.data.PhoneNumber;
        this.username = this.data.UserName;
    }

    showAlert(): void
    {
        this.alertDialog.open(AlertDialogComponent, {
            minWidth: '360px',
            disableClose: true,
            data: {
                title: 'Selection Required',
                message: 'Please select a verification method before continuing.',
                buttonText: 'Close'
            }
        });
    }

    onSelect(selectedMethod: string): void
    {
        if (!selectedMethod)
        {
            this.showAlert();
            return;
        }
        this.dialogRef.close(selectedMethod);
    }
}